<app-blog-detail [blog]="content()"></app-blog-detail>
